<template>
  <div id="app">
    <Menu></Menu>
    <main id="page-wrap" class="container-fluid">
      <transition name="fade" mode="out-in">
        <router-view class="" />
      </transition>
      <bottom></bottom>
    </main>
    <footer class="container-fluid">
        <div class="row">
          <div class="col pt-3 pb-3 d-flex justify-content-between ">
            <div>
              <h4 class="m-0">© {{new Date().getFullYear()}} | Rijnland Beveiliging<span class="invisible-sm"> | Endegeesterstraatweg 3, Oegstgeest</span></h4>
            </div>
            <div>
              <h4 class="m-0"><router-link tag="a" to="#" aria-label="Privacy">Privacy</router-link> | <router-link tag="a" to="#" aria-label="Voorwaarden">Voorwaarden</router-link></h4>
            </div>
          </div>
        </div>
    </footer>
  </div>
</template>

<script>
import Menu from '@/components/Menu';
import Bottom from '@/components/Bottom';
export default {
    components: {
        Menu,
        Bottom
    },
    data() {
      return {
        cities: ['Leiden', 'Voorschoten', 'Oegstgeest', 'Leiderdorp', 'Zoeterwoude', 'Katwijk', 'Noordwijk', 'Teylingen', 'Lisse', 'Hillegom', 'Kaag en Braassem', 'Alphen aande Rijn', 'Nieuwkoop']
      }
    },
    metaInfo() {
      return {
          title: 'Rijnland Beveiliging',
          titleTemplate: '%s | ' + this.$route.meta.title,
          link: [
              { rel: 'canonical', href: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href }
          ],
          htmlAttrs: {
              lang: 'nl',
              //amp: true
          },
          meta: [
              { name: 'description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Rijnland Beveiliging verzorgd in verschillende beveiligingsdiensten. Denk hierbij aan winkelsurveillanten, horecaportiers, evenementenbeveiligers, EHBO-ers en het beveiligen van objecten.' },
              { name: 'keywords', content: (!!this.$route.meta.keywords) ? this.$route.meta.keywords : 'Beveiliging, Beveiliger, Security, Inhuren, Freelance, Beveiliginsopdracht, Beveiliginsbedrijf, Huur, Vraag, Aanbod, Objectbeveiliger, Winkelsurveillance, Evenementenbeveiliger, Receptionist, Persoonsbeveiliger, Brandwacht, Verkeersregelaar, EHBO, Leiden, Oegstgeest' },
              
              { property: 'og:title', content: 'Rijnland Beveiliging ← ' + this.$route.meta.title },
              { property: 'og:site_name', content: 'Rijnland Beveiliging'},
              { property: 'og:type', content: 'website'},
              { property: 'og:url', content: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href },
              { property: 'og:image', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://rijnlandbeveiliging.nl/img/Logo-beveiliging_white.9731f3bb.png' },
              { property: 'og:description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Rijnland Beveiliging verzorgd in verschillende beveiligingsdiensten. Denk hierbij aan winkelsurveillanten, horecaportiers, evenementenbeveiligers, EHBO-ers en het beveiligen van objecten.'},

              { name: 'twitter:card', content: 'summary'},
              { name: 'twitter:site', content: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href },
              { name: 'twitter:title', content: 'Rijnland Beveiliging ← ' + this.$route.meta.title},
              { name: 'twitter:description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Rijnland Beveiliging verzorgd in verschillende beveiligingsdiensten. Denk hierbij aan winkelsurveillanten, horecaportiers, evenementenbeveiligers, EHBO-ers en het beveiligen van objecten.'},
              { name: 'twitter:creator', content: 'info@azurity.nl'},
              { name: 'twitter:image:src', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://rijnlandbeveiliging.nl/img/Logo-beveiliging_white.9731f3bb.png' },

              { itemprop: 'name', content: 'Rijnland Beveiliging ← ' + this.$route.meta.title},
              { itemprop: 'description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Rijnland Beveiliging verzorgd in verschillende beveiligingsdiensten. Denk hierbij aan winkelsurveillanten, horecaportiers, evenementenbeveiligers, EHBO-ers en het beveiligen van objecten.'},
              { itemprop: 'image', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://rijnlandbeveiliging.nl/img/Logo-beveiliging_white.9731f3bb.png' }

          ]
      }
    }
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "@/assets/styles.scss";

.bm-overlay {
  background: $darkColor !important;
}

body {
  background-color: $darkColor;
}

main {
  height: calc(100% - 50px);
}
footer {
  color: $lightColor;
  position: fixed;
  bottom:0;
  background-color: $darkColor;
  height: 50px;
  max-height: 50px;
  h4 {
    font-size: 14px;
  }
  a, a:hover {
    color: $lightColor;
  }
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $lightColor;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  left:0;
  right: 0;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.top {
  position: absolute;
  top:0;
  left: 0;
  right: 0;
  margin: auto;
  height: 65%;
  background-color: $darkColor;
}


.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}

.inline {
  display: inline-block;
}

.ellipsis {
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
}

.light-link,
.light-link:hover {
  color: $lightColor;
}

.region a {
  color: $lightColor;
}

.region a:hover {
  text-decoration: underline;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

@media only screen and (max-width: 768px) {
  .visible-sm {
    visibility: visible;
  }
  .invisible-sm {
    visibility: hidden;
    display: none !important;
  }
}

@media only screen and (min-width: 768px) {
  .visible-md {
    visibility: visible;
  }
  .invisible-md {
    visibility: hidden;
    display: none !important;
  }
}
</style>
